import { generateQueryKey } from 'query';
import type { GetInvitationTokenQueryParams } from './useInvitationTokenQuery';

const featureKey = 'invitation-tokens';

export const getInvitationTokensFeatureQueryKey = () => generateQueryKey([featureKey]);

export const getInvitationTokenQueryKey = ({ kind, subjectId, subjectType }: Partial<GetInvitationTokenQueryParams>) =>
  generateQueryKey([...getInvitationTokensFeatureQueryKey(), kind, subjectType, subjectId]);
